export * from './parametrage.model';
export * from './parametrage.service';
export * from './parametrage.component';
export * from './parametrage.route';
export * from './files/files.component';



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/parametrage/index.ts